import { Container } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import { connect } from 'react-redux';
import Page from 'src/components/Page';
import { getTasksRequest } from '../../store/actions/taskActions';
import { text } from "../../modules/languages/index";
import Header from 'src/components/Header';
import IletisimDetay from './ContactDetail';
const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  IletisimDetay: {
    marginTop: theme.spacing(1)
  },
}));



const ServisIletisim = () => {
  const classes = useStyles();

  return (
    <Page className={classes.root} title={text("Artemis_Atanan_isler")}>
      <Container maxWidth="lg">
        <Header />
        <IletisimDetay className={classes.IletisimDetay} />
      </Container>
    </Page>
  );
}


export default connect(
  state => ({ tasks: state.tasks1 })
  ,
  {
    getTasksRequest
  }
)(ServisIletisim);
